<div mat-dialog-title>
  <h2 class="my-0">
    {{ 'map.plotting.name' | translate }}
  </h2>
</div>
<div mat-dialog-content>
  <div class="container-fluid py-3">
    <div class="row" [ngClass]="{ 'mb-4': !!currentTemplate }">
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label> {{ 'map.plotting.title' | translate }}</mat-label>
          <input matInput [(ngModel)]="plotTitle" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label> {{ 'map.plotting.select_template' | translate }}</mat-label>
          <mat-select [(ngModel)]="currentTemplate" (selectionChange)="changedSelectedTemplate()">
            <mat-option *ngFor="let template of templateList" [value]="template">{{ template.title }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="currentTemplate" class="pb-4">
      <mat-divider></mat-divider>
    </div>

    <ebw-dynamic-form *ngIf="currentTemplate" formId="formPlot" (formSubmit)="onFormSubmit($event)"></ebw-dynamic-form>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button *ngIf="currentTemplate" mat-flat-button color="primary" class="mx-2 float-right" (click)="selectAreaClick()">
    <span>{{ 'map.plotting.select_area' | translate }}</span>
    <mat-icon
      aria-hidden="false"
      aria-label="Example home icon"
      [fontIcon]="getIcon()"
      class="select-area-icon"
    ></mat-icon>
  </button>
  <button mat-stroked-button [mat-dialog-close]="false" color="primary" class="mx-2">
    {{ 'common.close' | translate }}
  </button>
  <button mat-flat-button color="primary" class="mx-2" (click)="onSave()" [disabled]="!plotTitle || !currentTemplate || !dynamicForm?.form?.valid">
    {{ 'common.save' | translate }}
  </button>
</div>
